import React, { useEffect, useState } from 'react';
import { Tooltip, Form, Input, Select, Table, Button } from 'antd';
import { prefixCls } from '@/constants';
import { InfoCircleOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import AcorePagination from '@zero/pagination';
import PopupFllow from '@/components/popup-follow';
import ProductinfoInTable from '@/pages/activity-manage/compoennts/productinfo-in-table';
import apis from './apis';
import TreeSelectCategory, {
  validateSelectMax as validateSelectCategoryMax,
} from '@/form-component/tree-select-category';
import utils from '@/common/utils';
import TreeSelectDepartment, { validateSelectMax } from '@/form-component/tree-select-department';
import './index.less';

function getImgSrc(src) {
  if (!src) return src;
  return '//img13.360buyimg.com/imagetools/' + src;
}

function renderSkuType(skuType) {
  switch (skuType) {
    case 0:
      return '自营';
    case 1:
      return 'POP';
  }
  return '';
}

function renderMaType(skuType) {
  switch (skuType) {
    case 1:
      return '未完善';
    case 2:
      return '审核通过';
    case 3:
      return '审核驳回';
    case 4:
      return '审核中';
  }
  return '';
}

const ShopGeneralView = () => {
  const activityId = utils.getQuery('activityId');
  const [dataSource, setDataSource] = useState([]);
  const [params, setParams] = useState({
    activityId,
    totalCount: 0,
    page: 1,
    pageSize: 10,
  });
  const [shopData, setShopData] = useState([]);
  const [conditionsForm] = Form.useForm();

  useEffect(() => {
    if (activityId) {
      apis.getShopData(activityId).then((res) => {
        setShopData([
          {
            num: res.data.needMaterialCount,
            description: '商品总数',
            tips:
              '素材完善触达的商品总数。数据口径说明：全量触达时，商品数是盘货完成时刻的sku数量固定不变，详情中运营数据看板的sku数量为实时变化，可能存在数值不一致的情况。部分触达时，商品数是盘货结果缩减后的sku数量。',
          },
          {
            num: res.data.completeMaterialCount,
            description: '已完善素材商品数',
            tips: '指定类型基础素材已完善的商品数量。',
          },
          {
            num: `${(res.data.completeMaterialRate * 100).toFixed(2)}%`,
            description: '完善进度',
            tips: '已完善素材商品数/商品总数',
          },
        ]);
      });
      getTableData(params);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activityId]);

  const getTableData = (data) => {
    apis.getShopList(data).then((res) => {
      setDataSource([]);
      if (res.ret === '0') {
        setParams({
          ...data,
          ...{
            totalCount: res.data.totalCount,
            pageSize: res.data.pageSize,
            page: res.data.page,
          },
        });
        setDataSource(res.data.items);
      }
    });
  };

  function updatePageConditions(page, pageSize) {
    getTableData({ ...params, page, pageSize });
  }

  const columns = [
    {
      title: '商品信息',
      dataIndex: 'skuId',
      width: 420,
      render: (item, record) => (
        <ProductinfoInTable
          sku={record.skuId}
          goodsName={record.skuName}
          price={record.jdPrice}
          img={getImgSrc(record.skuImg)}
          stock={record.stock}
        />
      ),
    },
    {
      title: '商品属性',
      dataIndex: 'skuType',
      render: renderSkuType,
      width: 200,
    },
    {
      title: '报名人',
      dataIndex: 'pin',
      width: 200,
    },
    {
      title: '素材完善状态',
      dataIndex: 'materialStatus',
      render: renderMaType,
      width: 200,
    },
    {
      title: '完善时间',
      dataIndex: 'completeTime',
    },
  ];
  const dataCard = ({ num, description, tips }) => {
    return (
      <div className="data-card">
        <div className="card-number">{num}</div>
        <div className="card-description">
          {description}
          <Tooltip title={tips}>
            <InfoCircleOutlined />
          </Tooltip>
        </div>
      </div>
    );
  };

  const resetForm = () => {
    conditionsForm.resetFields();
  };

  const onFinish = (e) => {
    getTableData({ ...params, ...e, page: 1, pageSize: 10 });
  };

  return (
    <div className="shop-general-view">
      <div className="title">数据概览</div>
      <div className="tip">
        <ExclamationCircleFilled style={{ marginRight: 5 }} />
        数据总数超过10万时，数据同步时间较长，请耐心等待~
      </div>
      <div className="pool-data-overview-body">{shopData.map((item) => dataCard(item))}</div>
      <div className="data-table">
        <div className="data-left">
          <div className="title">筛选维度</div>
          <Form
            form={conditionsForm}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            autoComplete="off"
            onFinish={onFinish}
          >
            <Form.Item label="商品sku" name="skuId">
              <Input placeholder="请输入商品sku编号" />
            </Form.Item>
            <Form.Item label="素材完善状态" name="materialStatus">
              <PopupFllow>
                <Select allowClear placeholder="全部">
                  <Select.Option value="1">未完善</Select.Option>
                  <Select.Option value="2">审核通过</Select.Option>
                  <Select.Option value="3">审核驳回</Select.Option>
                  <Select.Option value="4">审核中</Select.Option>
                </Select>
              </PopupFllow>
            </Form.Item>
            <Form.Item name="skuType" label="商品属性">
              <PopupFllow>
                <Select allowClear placeholder="全部">
                  <Select.Option value="0">自营</Select.Option>
                  <Select.Option value="1">POP</Select.Option>
                </Select>
              </PopupFllow>
            </Form.Item>
            <Form.Item name="categoryThirdIdsStr" label="所属类目" rules={[{ validator: validateSelectCategoryMax }]}>
              <TreeSelectCategory placeholder="请选择类目" level={3} />
            </Form.Item>
            <Form.Item name="deptThirdIdsStr" label="所属部门" rules={[{ validator: validateSelectMax }]}>
              <TreeSelectDepartment placeholder="请选择部门" type={3} />
            </Form.Item>
            <Form.Item
              rules={[
                {
                  validator(rule, value, cb) {
                    if (!value) return cb();

                    const res = /^\d*$/.test(value);

                    if (!res) cb(new Error('店铺ID只能输入数字'));
                    else cb();
                  },
                },
              ]}
              name="shopId"
              label="所属店铺"
            >
              <Input placeholder="请输入店铺ID" maxLength={18} />
            </Form.Item>
          </Form>
          <div className="conditions-form-footer">
            <Button onClick={resetForm}>重置</Button>
            <Button onClick={() => conditionsForm.submit()} style={{ marginLeft: 10 }} type="primary">
              查询
            </Button>
          </div>
        </div>
        <div className="data-right">
          <div className="title">
            明细数据 <span className="pool-title-ext-info">共{params.totalCount}条</span>
          </div>
          <div>
            <Table columns={columns} dataSource={dataSource} pagination={false}></Table>
            <AcorePagination
              pageSizeOptions={[10, 20, 50]}
              total={params.totalCount}
              onChange={(e, a) => updatePageConditions(e, a)}
              current={params.page}
              className={prefixCls + '-table-pagination ' + prefixCls + '-table-pagination-right'}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopGeneralView;
